module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-4-photo-7-bd0305e1f1de6484995cfee9c3b201c2.webp";